import React, { useEffect, useContext } from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { clearAlert } from '@store/reducers/alerts';
import { history } from '@utils/history';
import fonts from '@styles/fonts';
import globalStyles from '@styles/globals';
import animations from '@styles/animations';
import utilityClasses from '@styles/utilityClasses';

import { AlertMessage } from '@common-components/alert/alertMessage';
import { LoginPage } from '@components/login/loginPage';
import { RegisterPage } from '@components/register/registerPage';
import { NotFound404Page } from '@components/not-found/notFound404Page';
import { UnAuthorizePage } from '@components/unauthorize/unAuthorizePage';
import { AuthenticatedRoutes } from '@routes/authenticatedRoutes';

import _JSXStyle from 'styled-jsx/style';
import { ROUTES, AUTH } from '@constants';

import { AppContext } from 'commons/contexts/AppContext';


if (typeof global !== 'undefined') {
  Object.assign(global, { _JSXStyle });
}

/**
 * Main App. Component containing main routes
 * @returns {React.ReactElement}
 */
export const App = ({ authLoginMethod }) => {
  const dispatch = useDispatch();
  const { setAuthLoginMethod } = useContext(AppContext);

  useEffect(() => {
    setAuthLoginMethod(authLoginMethod);
  }, [authLoginMethod, setAuthLoginMethod]);

  useEffect(() => {
    history.listen(() => {
      // clear alerts on location change
      dispatch(clearAlert());
    });
  }, []);

  return (
    // TODO: Add skip links to Main-navigation and Main-content out of viewport for AT
    // TODO: Add fixed widget for Test the bot at the bottom of the main-content
    <>
      <div className="App horizontal-centered-flex">
        <div className="page-layout">
          <AlertMessage />
          <Router history={history}>
            {authLoginMethod === AUTH.ONEACCOUNT_LOGIN ? (
              <Switch>
                <Route exact path={ROUTES.unauthorized.path} component={UnAuthorizePage} />
                <Route component={AuthenticatedRoutes} />
                <Route component={NotFound404Page} />
              </Switch>
            ) : (
              <Switch>
                <Route exact path={ROUTES.login.path} component={LoginPage} />
                <Route exact path={ROUTES.register.path} component={RegisterPage} />
                <Route component={AuthenticatedRoutes} />
                <Route component={NotFound404Page} />
              </Switch>
            )}
          </Router>
        </div>
      </div>
      <footer className="centered-flex">
        <p>
          Made with{' '}
          <span role="img" aria-label="heart" style={{ color: '#ef6461' }}>
            ❤
          </span>{' '}
          and powered by{' '}
          <a target="_blank" rel="noopener noreferrer" href="https://github.com/axa-group/nlp.js">
            NLP.js{' '}
          </a>
          <span role="img" aria-label="brain" style={{ color: '#ef6461' }}>
            🧠
          </span>
        </p>
        <style jsx>{fonts}</style>
        <style jsx>{globalStyles}</style>
        <style jsx>{animations}</style>
        <style jsx>{utilityClasses}</style>
      </footer>
    </>
  );
};
